import { fExecuteAPI } from "../../Server/Apis";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";

import moment from "moment";
import { KernCAConfig, vRdxUserInfo, WmsPhysicalStockCountRo } from "../../Redux/roStore";
import { Set_SliceWmsPhysicalStockCount_CountingDetail, Set_SliceWmsPhysicalStockCount_HeadObject_SheetNo_A_DocStat } from "./SliceWmsPhysicalStockCount";
import {
  Physical_Stock_Count_Approve,
  Physical_Stock_Count_Save,
  PhysicalStock_Detail_Load,
  PhysicalStockCount_onLoad_Attribute,
} from "../../Server/ApiV2";
// item
export const GCToggleSearch_ItemName_Columns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "ItmCd", headerName: "ItmCd", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "NameFL", headerName: "NameFL", width: 90 },
  { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
  { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
  { field: "Model", headerName: "Model", width: 90 },
  { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
  { field: "BarCode", headerName: "BarCode", width: 90 },
];

export const CountArr = [
  {
    UID: "All",
    Name1: "All",
  },
  {
    UID: "Count01",
    Name1: "Count-01",
  },
  {
    UID: "Count02",
    Name1: "Count-02",
  },
  {
    UID: "Count03",
    Name1: "Count-03",
  },
];

export const StatusArr = [
  {
    "id": "All",
    "statusName": "All"
  },
  {
    "id": "ENTER",
    "statusName": "ENTER"
  },
  {
    "id": "POST",
    "statusName": "POST"
  }
]
export const CountAndAllArr = [
  {
    UID: "Count01",
    Name1: "Count-01",
  },
  {
    UID: "Count02",
    Name1: "Count-02",
  },
  {
    UID: "Count03",
    Name1: "Count-03",
  },
];
export const GCToggleSearch_ItemName_Select_Arr = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

//customer
export const xGC_Toggle_Head_BinName_GridColumns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "UId", headerName: "Code", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "BinAttr1", headerName: "BinAttr1", width: 450 },
  // { field: "Name1", headerName: "Name1", width: 220 },
];
export const xGC_Toggle_Head_BinName_DropDown_Arr = ["Any", "Code", "Name"];

export let Summary_Grid_Columns = [
  {
    field: "binName",
    headerName: "Bin Name",
    width: 150,
  },
  {
    field: "level",
    headerName: "Level",
    width: 200,
  },
  {
    field: "A_PDT_User_Name",
    headerName: "Existi Assigned User",
    width: 200,
  },
];
export const Detail_Grid_columns = [
  {
    field: "B_SheetId",
    headerName: "Sheet No",
    width: 150,
    hide: true,
  },
  {
    field: "B_SrNo",
    headerName: "Sr No",
    width: 50,
  },
  {
    field: "B_CardID",
    headerName: "CardID",
    width: 150,
  },
  {
    field: "B_ItmCd",
    headerName: "Item Code",
    width: 90,
    hide: true,
  },
  {
    field: "ItmName",
    headerName: "Item Name",
    width: 320,
  },
  {
    field: "B_BinCd",
    headerName: "BinCd",
    width: 50,
    hide: true,
  },
  {
    field: "BinName",
    headerName: "BinName",
    width: 300,
  },

  {
    field: "B_Qty",
    headerName: "Qty",
    width: 50,
  },
  {
    field: "B_Unit",
    headerName: "Unit",
    width: 100,
  },
  {
    field: "B_BaseQty",
    headerName: "Base Qty",
    width: 100,
  },
];
export const ErrorMsgDetail = {
  B_Srno: "", // int
  B_CardId: "",
  B_Itmcd: "",
  B_ItmName: "",
  B_BinCode: "",
  B_BinName: "",
  B_Qty: "", //Decimal
  B_Unit: "",
  B_UnitName: "",
  B_PackQty: "", //Decimal
  B_Packing: "", //Decimal
  B_BaseQty: "", //Decimal
};

export const sTrnTyp = "WMIPT01";

const GetItemFullSearchArr = async (xItemName, xLoc) => {
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI("SEARCHEXACTITEM_GETROW", FinalObj);
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull?.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull?.Type?.response?.data?.message
        ? vItemSearchFull?.Type?.response?.data?.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("GETITEMUNITS_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
    return [];
  }
};

export const MultiCardFlag = () => {
  const { DBKernObj } = KernCAConfig();

  const iShowField = DBKernObj.MULT_CARD_ID?.Val === 'Y';
  if (iShowField) {
    return true;
  } else {
    return false;
  }
};
const fItemCodeDependency = async (
  vItemSearchFull,
  setBufferObj,
  setUnit,
  defUnitValue = ""
) => {
  if (vItemSearchFull.length > 0) {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
      BarCode: vItemSearchFull[0].BarCode,
    }));
    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    if (currentUnitArr.length > 0) {
      let vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === defUnitValue;
      });
      if (!!vItemUnitSet) {
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: vItemUnitSet.Unit,
          B_UnitName: vItemUnitSet.Name1,
          B_PackQty: vItemUnitSet.PackQty,
          B_Packing: vItemUnitSet.PackDesc,
        }));
      } else {
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: currentUnitArr[0].Unit,
          B_UnitName: currentUnitArr[0].Name1,
          B_PackQty: currentUnitArr[0].PackQty,
          B_Packing: currentUnitArr[0].PackDesc,
        }));
      }
      // let vItemUnitSet = currentUnitArr.find((obj) => {
      //   return obj.Unit === vItemSearchFull[0].DefUnit;
      // });
      // if (!!vItemUnitSet) {
      //   setBufferObj((obj) => ({
      //     ...obj,
      //     B_Unit: vItemUnitSet.Unit,
      //     B_UnitName: vItemUnitSet.Name1,
      //     B_PackQty: vItemUnitSet.PackQty,
      //   }));
      // } else {
      //   let vItemUnitSet = currentUnitArr.find((obj) => {
      //     return obj.Unit === vItemSearchFull[0].PurUOM;
      //   });
      //   if (!!vItemUnitSet) {
      //     setBufferObj((obj) => ({
      //       ...obj,
      //       B_Unit: vItemUnitSet.Unit,
      //       B_UnitName: vItemUnitSet.Name1,
      //       B_PackQty: vItemUnitSet.PackQty,
      //     }));
      //   } else {
      //     setBufferObj((obj) => ({
      //       ...obj,
      //       B_Unit: currentUnitArr[0].Unit,
      //       B_UnitName: currentUnitArr[0].Name1,
      //       B_PackQty: currentUnitArr[0].PackQty,
      //     }));
      //   }
      // }
    }
    setTimeout(() => {
      const element = document.querySelector('[tabindex="104"]');
      element?.focus();
    }, 500);
    // document.getElementsByName("GC_Toggle_Head_BinName_Name")[0].focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch?.Type?.toUpperCase() === "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};
const fValidationHead_Client = (
  vRdxHead,
  setErrorMsg,
  vMediaQuery,
  fSummary
) => {
  let iRes = true;
  // let xObjHasNullOrUndefinevale =
  //   fCheck_Value_Null_Or_Undefined_ShowAlert(vRdxHead);
  // fAlertToast("WARNING", xObjHasNullOrUndefinevale);
 
  if (
    vRdxHead.sheetID === "" ||
    vRdxHead.sheetID === null ||
    vRdxHead.sheetID === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      SheetNo: "Sheet Number should not be empty",
    }));

    iRes = false;
  }

  if (
    vRdxHead.locCode === "" ||
    vRdxHead.locCode === null ||
    vRdxHead.locCode === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({ ...obj, Loc: "Location should not be empty" }));
    iRes = false;
  }

  // default format so no need to check format

  if (vRdxHead.countStatus !== "ENTER") {
    fAlertToast("FAILED", "Document status should be  Enter");
    iRes = false;
  }

  return iRes;
};

const fValidationDetail_Client = (sBufferObj, setErrorMsgDetail) => {
  let iRes = true;
  if (sBufferObj.B_Srno === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_CardId === "" ||
    sBufferObj.B_CardId === null ||
    sBufferObj.B_CardId === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_CardId: "CardId should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_BinCode === "" ||
    sBufferObj.B_BinCode === null ||
    sBufferObj.B_BinCode === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_BinCode: "BinCode should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_BinName === "" ||
    sBufferObj.B_BinName === null ||
    sBufferObj.B_BinName === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_BinName: "BinName should not be empty",
    }));
    iRes = false;
  }
 
  const { CountingDetail } = WmsPhysicalStockCountRo();
  if (
    sBufferObj.B_BinCode != CountingDetail.binCode
  ) {
    fAlertToast("FAILED", `Assign bin ${CountingDetail.binCode} and bin ${sBufferObj.B_BinCode} should be same`);
  
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_BinName: `Assign bin ${CountingDetail.binCode} and bin ${sBufferObj.B_BinCode} should be same`,
    }));
    iRes = false;
  }
  if (
    sBufferObj.B_Itmcd === "" ||
    sBufferObj.B_Itmcd === null ||
    sBufferObj.B_Itmcd === undefined
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    iRes = false;
  }

  if (sBufferObj.B_ItmName === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_Qty === "" ||
    // Number(sBufferObj.B_Qty) <= 0 ||
    (sBufferObj.B_Qty === null) | (sBufferObj.B_Qty === undefined)
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty: "Qty should not be zero",
    }));
    iRes = false;
  }

  if (sBufferObj.B_Unit === "") {
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    iRes = false;
  } else if (sBufferObj.B_PackQty === "" || Number(sBufferObj.B_PackQty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Unit: "Pack quantity should not be zero",
    }));
    iRes = false;
  }

  return iRes;
};
export const get_Attribute =  async (setNewAttribute) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var loc = { 
    userCd: vRdxUserInfoObj.UserID, 
  };
  let FinalObj = fcheck_null_undefine_replace_empty(loc);
  const iResp = await PhysicalStockCount_onLoad_Attribute(FinalObj);
  if (iResp?.status == 200) {
    setNewAttribute(iResp?.data.ResultSet);
    return iResp?.data.ResultSet
  } 
} 
//API SaveSIHead
const fSaveHead = async (xSave, fNewDetail, sBufferObj, dispatch) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObj } = WmsPhysicalStockCountRo();
  const iStatus = xSave ? HeadObj.A_DocStat : "POST"; //xSave False means Post
  let vSaveSIHeadObj = {
    A_SheetId: HeadObj.SheetNo,
    A_Loc: HeadObj.Loc,
    A_Date: moment(HeadObj.Date).format("MM/DD/YYYY"),
    A_Status: iStatus,
    A_RefNo: HeadObj.ReferenceNo,
    UserCd: vRdxUserInfoObj.UserID,
    IP: vRdxUserInfoObj.IP,
    CountType: HeadObj.Count,
    PDTUser: HeadObj.User,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);
  const vSaveSIHead = await fExecuteAPI("WMIPT01_saveHead_GETROW", FinalObj);
  if (vSaveSIHead?.Type?.toUpperCase() === "SUCCESS") {
    dispatch(
      Set_SliceWmsPhysicalStockCount_HeadObject_SheetNo_A_DocStat({
        SheetNo: xSave ? vSaveSIHead?.ResultSet[0]?.SheetId : HeadObj.SheetNo,
        A_DocStat: iStatus,
      })
    );

    //approve bool type false
    if (!xSave) {
      fAlertToast("SUCCESS", "Successfully posted");
    } else {
      fSaveDetail(sBufferObj, fNewDetail);
    }
  } else if (vSaveSIHead?.Type?.toUpperCase() === "FAILED") {
    fAlertToast("FAILED", vSaveSIHead.Status);
  } else {
    fAlertToast(
      "FAILED",
      !!vSaveSIHead.response.data.Status
        ? vSaveSIHead?.response?.data?.Status
        : "Fail to Save Head"
    );
  }
};

export const fApproveDetail = async (dispatch,navigate) => {
  const { CountingDetail } = WmsPhysicalStockCountRo();

  let resp = await Physical_Stock_Count_Approve({
    SheetId: CountingDetail.sheetID,
    BinCd: CountingDetail.binCode,
    Status: "POST",
  });
  if (resp.status == 200) {
    dispatch(
      Set_SliceWmsPhysicalStockCount_CountingDetail({
        ...CountingDetail,
        countStatus: 'POST',
      })
    );
    fAlertToast("SUCCESS", "Successfully Posted");
    navigate("/WmsPhysicalStockCount")
  }
};
const fSaveDetail = async (sBufferObj, fNewDetail) => {
  const { CountingDetail } = WmsPhysicalStockCountRo();
  let vSaveSIDetailObj = {
    B_SheetId: CountingDetail.sheetID,
    B_SrNo: sBufferObj.B_Srno,
    B_CardID: sBufferObj.B_CardId,
    B_BinCd: sBufferObj.B_BinCode,
    B_ItmCd: sBufferObj.B_Itmcd,
    B_Qty: sBufferObj.B_Qty,
    B_Unit: sBufferObj.B_Unit,
    B_BinName: sBufferObj.B_BinName,
    B_LocCd: CountingDetail.locCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIDetailObj);
  // const vSaveSIDetail = await fExecuteAPI(
  //   "WMIPT01_saveDetail_GETROW",
  //   FinalObj
  // );
  const vSaveSIDetail = await Physical_Stock_Count_Save(FinalObj);
  if (vSaveSIDetail?.status === 200) {
    fNewDetail();
    fAlertToast("SUCCESS", "Successfully Saved");
  } else {
    console.log(vSaveSIDetail);
  }
};

const GetSIDetail = async () => {
  const { CountingDetail } = WmsPhysicalStockCountRo();
  let iSIDetailObj = {
    v_B_SheetId: CountingDetail?.sheetID,
    v_B_BinCd: CountingDetail?.binCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const iSIDetailResult = await PhysicalStock_Detail_Load(FinalObj);
  if (iSIDetailResult?.status == 200) {
    if (iSIDetailResult?.data?.ResultSet?.length > 0) {
      return iSIDetailResult.data.ResultSet;
    } else {
      return [];
    }
  }
};
const fLoad_Grid = async (setDetailGridData) => {
  const iSIDetail = await GetSIDetail();
  if (iSIDetail?.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
  } else {
    setDetailGridData([]);
  }
};

export {
  GetItemFullSearchArr,
  GetUnitArr,
  fItemCodeDependency,
  GetSearchItem,
  fValidationDetail_Client,
  fValidationHead_Client,
  fLoad_Grid,
  fSaveHead,
  fSaveDetail,
};
